<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex md12 sm12 lg2 >
                <v-tooltip top>
                    <v-btn slot="activator" class="mt-4" absolute right fab dark top color="primary dark1" @click="showAddModal = true">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                    <span>{{$t('Core.Fields.add_new')}}</span>
                </v-tooltip>

            </v-flex>
            <v-flex md12 sm12 lg12>
                <document-types-table @refresh="getItems" @edit="editItem" @delete="deleteItem" :total="total" :loading="loading" :items="items"></document-types-table>
            </v-flex>
        </v-layout>
        <add-modal @refresh="getItems" v-model="showAddModal" :documentType="selectedDocumentType" @close="showAddModal = false, selectedDocumentType = null"></add-modal>
    </v-container>
</template>

<script>
  import DocumentTypesTable from './documentTypes/Table'
  import AddModal from './documentTypes/AddModal'
  
  export default {
    name: "DocumentTypes",
    components: { DocumentTypesTable, AddModal },
    data: () => ({
      items: [],
      initial: true,
      loading: false,
      total: 0,
      pagination: {},
      selectedDocumentType: null,
      showAddModal: false
    }),
    created () {

    },
    methods: {
      getItems(data = null){
        this.pagination = data;
        if(this.initial){
          this.setFetching(true);
        }
        this.loading = true;
        this.repositories.documentType.paginate(data)
          .then(response => {
            this.items = response.data.data;
            this.total = response.data.meta.pagination.total;
          }).finally(() => {
            this.loading = this.initial = false;
            this.setFetching(false);
          });
      },
      editItem(item) {
        this.selectedDocumentType = item;
        this.showAddModal = true;
      },
      deleteItem(item){
        this.repositories.documentType.delete(item.id)
          .then(response => {
            this.$toast.info(response.data.message);
            this.getItems(this.pagination);
          })
      }
    }
  }
</script>

<style scoped>

</style>